var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 99.9 90.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #f17834;\n        stroke-width: 4px;\n      }\n\n      .cls-2 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-3, .cls-4 {\n        display: none;\n      }\n\n      .cls-4 {\n        fill: #ff1414;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "position_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    className: "cls-4",
    d: "M70.2,85.2l2.6,2.1c3.1-3.8,4.9-8.5,5.3-13.4,0-.7,0-1.3,0-2-.4-8.5-1.3-17-3-25.3l-3.3.6c1.6,8.2,2.6,16.4,2.9,24.8,0,.6,0,1.2,0,1.8-.3,4.2-1.9,8.3-4.6,11.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    className: "cls-4",
    d: "M98.2,5h-8.3v-1.7c0-.9-.7-1.7-1.7-1.7,0,0,0,0,0,0h-10c-.9,0-1.7.7-1.7,1.7h0v11.7h-6.7c0-2.8-2.2-5-5-5h0c-.6,0-1.1.1-1.7.3v-.3c0-2.8-2.2-5-5-5-.6,0-1.1.1-1.7.3v-.3c0-2.8-2.3-5-5-5-2.2,0-4.2,1.5-4.8,3.7-2.6-1-5.5.2-6.5,2.7-.2.6-.4,1.2-.4,1.9v6.7h-13.4V3.3c0-.9-.7-1.7-1.7-1.7,0,0,0,0,0,0h-10c-.9,0-1.7.7-1.7,1.7h0v1.7H4.7c-.9,0-1.7.7-1.7,1.7v30.1c0,.9.7,1.7,1.7,1.7h8.3v1.7c0,.9.7,1.7,1.7,1.7h10c.9,0,1.7-.7,1.7-1.7v-11.7h5.5c.8,2.3,2.4,4.3,4.5,5.5l6.6,3.8v20.2c-5.3-1.9-11-2.9-16.7-2.8-19,0-26.1,10.3-26.4,10.8l2.8,1.9c.3-.4,6.5-9.3,23.7-9.3s23.7,7.7,23.7,7.7l2.6-2.1c-1.8-2-3.9-3.5-6.3-4.7v-22.7c0-.6-.3-1.2-.8-1.5l-7.5-4.3c-2.1-1.2-3.4-3.5-3.4-6,0-3,2.1-5.7,5-6.4v4.8h3.3v-15c0-.9.7-1.7,1.6-1.7s1.7.7,1.7,1.6c0,0,0,0,0,0v5h3.3V5c0-.9.7-1.7,1.6-1.7s1.7.7,1.7,1.6c0,0,0,0,0,0v10h3.3v-5c0-.9.7-1.7,1.6-1.7s1.7.7,1.7,1.6c0,0,0,0,0,0v6.7h3.3v-1.7c0-.9.7-1.7,1.6-1.7.9,0,1.7.7,1.7,1.6,0,0,0,0,0,0v14.6l-3.2,6.3c-.2.3-.2.7-.1,1.1,0,.2,5,23.3,5,34.7s0,.9,0,1.3c-.8,7.9-7.4,13.8-15.3,13.7H1.4v3.3h51.4c9.7.1,17.8-7.2,18.7-16.8,0-.5,0-1,0-1.5,0-10.8-4.1-31.1-4.9-34.8l3.1-6.2c.1-.2.2-.5.2-.7v-1.7h6.7v11.7c0,.9.7,1.7,1.7,1.7h10c.9,0,1.7-.7,1.7-1.7v-1.7h8.3c.9,0,1.7-.7,1.7-1.7V6.7c0-.9-.7-1.7-1.7-1.7ZM6.4,35.1v-5h3.3v-3.3h-3.3v-3.3h3.3v-3.3h-3.3v-3.3h3.3v-3.3h-3.3v-5h6.7v26.7h-6.7ZM23.1,38.4h-6.7V5h6.7v33.4ZM26.4,18.4h7.6c-1.6,1.8-2.6,4.2-2.6,6.7h-5v-6.7ZM69.8,25v-6.7h6.7v6.7h-6.7ZM86.5,38.4h-6.7V5h6.7v33.4ZM89.9,35.1V8.3h6.7v5h-3.3v3.3h3.3v3.3h-3.3v3.3h3.3v3.3h-3.3v3.3h3.3v5h-6.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    className: "cls-4",
    d: "M42.3,69l1.7-2.9c-5.4-3-11.4-4.5-17.6-4.3-3.6,0-7.1.5-10.5,1.6l1.1,3.2c3.1-1,6.3-1.5,9.5-1.5,5.5-.2,11,1.2,15.8,3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    className: "cls-4",
    d: "M12.3,64.9c-1.2.6-2.4,1.3-3.6,2.1l1.9,2.7c1-.7,2-1.3,3.1-1.9l-1.5-3Z"
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-3",
    width: 512,
    height: 512,
    transform: "scale(.2 .2)",
    xlinkHref: "C:\\\\\\\\Users\\\\\\\\user\\\\\\\\Desktop\\\\\\\\5481993.png"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.1,45.1s23.7-21.1,48.8-21.1,46.9,21.1,46.9,21.1c0,0-23.3,21.3-46.6,21.3S2.1,45.1,2.1,45.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 49.9,
    cy: 45,
    r: 19.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 49.7,
    cy: 45.8,
    r: 7.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 74.6,
    y1: 67.3,
    x2: 86,
    y2: 77.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 49.9,
    y1: 74.2,
    x2: 49.9,
    y2: 88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 25,
    y1: 67.3,
    x2: 13.8,
    y2: 77.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 74.6,
    y1: 21.7,
    x2: 85.3,
    y2: 12.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 49.9,
    y1: 15.9,
    x2: 49.9,
    y2: 2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.8,
    y1: 12.6,
    x2: 25,
    y2: 22.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.e1bebc1fcbca8a3a3117b55b781a41bd.svg";
export { ForwardRef as ReactComponent };